module.exports = require("vue-server-renderer");


//////////////////
// WEBPACK FOOTER
// external "vue-server-renderer"
// module id = 48
// module chunks = 0